/* eslint-disable */ !(function (s) {
  s.Redactor.prototype.fullscreen = function () {
    return {
      init: function () {
        this.fullscreen.isOpen = !1;
        var t = this.button.add('fullscreen', this.lang.get('fullscreen'));
        this.button.addCallback(t, this.fullscreen.toggle),
          this.opts.fullscreen && this.fullscreen.toggle();
      },
      enable: function () {
        this.button.changeIcon('fullscreen', 'normalscreen'),
          this.button.setActive('fullscreen'),
          (this.fullscreen.isOpen = !0),
          this.opts.toolbarExternal &&
            ((this.fullscreen.toolcss = {}),
            (this.fullscreen.boxcss = {}),
            (this.fullscreen.toolcss.width = this.$toolbar.css('width')),
            (this.fullscreen.toolcss.top = this.$toolbar.css('top')),
            (this.fullscreen.toolcss.position = this.$toolbar.css('position')),
            (this.fullscreen.boxcss.top = this.$box.css('top'))),
          (this.fullscreen.height = this.$editor.height()),
          this.opts.maxHeight && this.$editor.css('max-height', ''),
          this.opts.minHeight && this.$editor.css('min-height', ''),
          this.$fullscreenPlaceholder ||
            (this.$fullscreenPlaceholder = s('<div/>')),
          this.$fullscreenPlaceholder.insertAfter(this.$box),
          this.$box.appendTo(document.body),
          this.$box.addClass('redactor-box-fullscreen'),
          s('body, html').css('overflow', 'hidden'),
          this.fullscreen.resize(),
          s(window).on(
            'resize.redactor.fullscreen',
            s.proxy(this.fullscreen.resize, this)
          ),
          s(document).scrollTop(0, 0),
          s('.redactor-toolbar-tooltip').hide(),
          this.$editor.focus(),
          this.observe.load();
      },
      disable: function () {
        this.button.removeIcon('fullscreen', 'normalscreen'),
          this.button.setInactive('fullscreen'),
          (this.fullscreen.isOpen = !1),
          s(window).off('resize.redactor.fullscreen'),
          s('body, html').css('overflow', ''),
          this.$box.insertBefore(this.$fullscreenPlaceholder),
          this.$fullscreenPlaceholder.remove(),
          this.$box
            .removeClass('redactor-box-fullscreen')
            .css({ width: 'auto', height: 'auto' }),
          this.code.sync(),
          this.opts.toolbarExternal &&
            (this.$box.css('top', this.fullscreen.boxcss.top),
            this.$toolbar.css({
              width: this.fullscreen.toolcss.width,
              top: this.fullscreen.toolcss.top,
              position: this.fullscreen.toolcss.position
            })),
          this.opts.minHeight &&
            this.$editor.css('minHeight', this.opts.minHeight),
          this.opts.maxHeight &&
            this.$editor.css('maxHeight', this.opts.maxHeight),
          s('.redactor-toolbar-tooltip').hide(),
          this.$editor.css('height', 'auto'),
          this.$editor.focus(),
          this.observe.load();
      },
      toggle: function () {
        this.fullscreen.isOpen
          ? this.fullscreen.disable()
          : this.fullscreen.enable();
      },
      resize: function () {
        if (this.fullscreen.isOpen) {
          var t = this.$toolbar.height(),
            e =
              s(window).height() -
              t -
              this.utils.normalize(this.$editor.css('padding-top')) -
              this.utils.normalize(this.$editor.css('padding-bottom'));
          this.$box.width(s(window).width()).height(e),
            this.opts.toolbarExternal &&
              (this.$toolbar.css({
                top: '0px',
                position: 'absolute',
                width: '100%'
              }),
              this.$box.css('top', t + 'px')),
            this.$editor.height(e);
        }
      }
    };
  };
})(jQuery);
